// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/dashboard.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetOverviewRequest, GetOverviewResponse, GetPerformanceHistoryRequest, GetPerformanceHistoryResponse, GetPnLTrendRequest, GetPnLTrendResponse } from "./dashboard_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * DashboardService provides workspace-level rollups and trends.
 *
 * Every stats payload is a dynamic tracker.v1.StatsRow (metric key → decimal
 * string) generated from the workspace's goal registry; the metric catalog
 * comes from ReportingSchemaService.GetReportingSchema.
 *
 * @generated from service tracker.v1.DashboardService
 */
export const DashboardService = {
  typeName: "tracker.v1.DashboardService",
  methods: {
    /**
     * @generated from rpc tracker.v1.DashboardService.GetOverview
     */
    getOverview: {
      name: "GetOverview",
      I: GetOverviewRequest,
      O: GetOverviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.DashboardService.GetPnLTrend
     */
    getPnLTrend: {
      name: "GetPnLTrend",
      I: GetPnLTrendRequest,
      O: GetPnLTrendResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.DashboardService.GetPerformanceHistory
     */
    getPerformanceHistory: {
      name: "GetPerformanceHistory",
      I: GetPerformanceHistoryRequest,
      O: GetPerformanceHistoryResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

